import * as React from "react";
import ChangePasswordPageContainer from "../../containers/changepassword/ChangePasswordPageContainer";

export default class ChangePasswordPage extends React.Component
{
    public render()
    {
        return (
            <section key="dashboard-body" className="dashboard-body">
                <ChangePasswordPageContainer />
            </section>
        );
    }
}
